import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class Breadcrumbs extends React.Component {
  render () {
    const segments = this.props.segments.map(e => {
      if (!e.focusViewObject) { return; }

      const classes = {
        "terminal-segment": e.terminal
      };
      const title = e.focusViewObject.title;

      return <div key={title} className={classNames(classes)}>
        <a onClick={this.props.segmentClick(e.onClick)}>{title}</a>
      </div>;
    });

    return (
      <div className="breadcrumbs row">
        <div className="btn-group btn-breadcrumb">
          {segments}
        </div>
      </div>
    );
  }
}

Breadcrumbs.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    focusViewObject: PropTypes.shape({ title: PropTypes.string.isRequired }),
    onClick: PropTypes.func.isRequired,
    terminal: PropTypes.bool.isRequired
  })),
  segmentClick: PropTypes.func.isRequired
};

export default Breadcrumbs;
